import ReactDOM from 'react-dom'
import React, {Component} from 'react';
// 使用方法
//直接引入即可，会直接将内容append添加到body下面
// import PopupMask from '../../common/PopupMask'
//<PopupMask>
//      内容
// </PopupMask>
class PopupMask extends Component {
    constructor(props) {
        super(props)
    }

    componentWillUnmount() {
        this.popupNode.remove()
    }

    createContainer() {
        if (!this.popupNode) {
            const el = document.createElement('div');
            el.setAttribute('class', 'popup_mask');
            this.popupNode = el;
            document.body.appendChild(el)
        }
        return this.popupNode;
    }

    creatContent() {
        return (
            <div className='popup_content'>
                {this.props.children}
            </div>
        )
    }

    render() {
        return ReactDOM.createPortal(
            this.creatContent(),
            this.createContainer()
        ) //此处需返回null 避免报错
    }
}

export default PopupMask;